export const POPULAR_GOOGLE_FONTS = [
  "Inter",
  "Roboto",
  "Open Sans",
  "Montserrat",
  "Poppins",
  "Lato",
  "Oswald",
  "Raleway",
  "Playfair Display",
  "Space Grotesk",
  "Merriweather",
  "Nunito",
  "Outfit",
  "Rubik",
  "Ubuntu",
  "Lora",
  "Bebas Neue",
  "PT Sans",
  "PT Serif",
  "Josefin Sans",
  "Quicksand",
  "Work Sans",
  "Fira Sans",
  "DM Sans",
  "Manrope",
  "Karla",
  "Mulish",
  "Inconsolata",
  "Titillium Web",
  "Cabin",
  "Mukta",
  "Heebo",
  "Barlow",
  "Nunito Sans",
  "Libre Baskerville",
  "Arimo",
  "Bitter",
  "Anton",
  "Dosis",
  "Hind",
  "Varela Round",
  "Cormorant Garamond",
  "Teko",
  "Oxygen",
  "Kanit",
  "Zilla Slab",
  "Asap",
  "Exo 2",
  "Nanum Gothic"
];
